import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../models';
import { ColumnContextualizer, contextualizeColumnsField } from './contextualize-columns.helper';

/**
 * Given a collection of columns it replaces the field path with with given parameter
 * if no given parameter the first item before a '/' will be replaced with empty string
 * as default, if parameter is a string it will replace the first occurrence of the token
 * in the field, if a function is given, the function is applied as the context transformer
 *
 * @example
 * {{ [] | contextualizeColumns  }} // -> removes the token before first '/'
 * {{ [] | contextualizeColumns: 'a' }}  // -> removes the token of 'a/' in field value
 * {{ [] | contextualizeColumns: fnOfContextualizerType  }} // -> function is applied to transform field
 * // and is considered as the context
 */
@Pipe({
  name: 'contextualizeColumns',
  standalone: false,
})
export class ContextualizeColumnsPipe implements PipeTransform {
  transform(columns: Column[], contextualizeWith?: string | ColumnContextualizer): Column[] {
    return contextualizeColumnsField(columns, contextualizeWith);
  }
}
